// extracted by mini-css-extract-plugin
export var anchorContainer = "companyReviewWidget-module--anchorContainer--i3ZR6";
export var anchorContainerVisible = "companyReviewWidget-module--anchorContainerVisible--91D2e";
export var ctaWidgetContainer = "companyReviewWidget-module--ctaWidgetContainer--3uLPG";
export var ctaWidgetContainerVisible = "companyReviewWidget-module--ctaWidgetContainerVisible--hEY+b";
export var leftSideTextContainer = "companyReviewWidget-module--leftSideTextContainer--6c9ZJ";
export var leftSideTextContainerVisible = "companyReviewWidget-module--leftSideTextContainerVisible--pXpHb";
export var leftStripe = "companyReviewWidget-module--leftStripe--GBNwB";
export var mobileFullWidth = "companyReviewWidget-module--mobileFullWidth--iNbxt";
export var pinkCta = "companyReviewWidget-module--pinkCta--4ZdEF";